import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateEnhancedTextElementButton_CreateEnhancedTextElementMutation } from "@relay/CreateEnhancedTextElementButton_CreateEnhancedTextElementMutation.graphql";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const CREATE_ENHANCED_TEXT_ELEMENT_MUTATION = graphql`
	mutation CreateEnhancedTextElementButton_CreateEnhancedTextElementMutation(
		$input: CreateEnhancedTextElementInput!
	) {
		Admin {
			ElearningV2 {
				createEnhancedTextElement(input: $input) {
					eLearningContentNode {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

type OwnProps = {
	eLearningContentNodeId: string;
};

export const CreateEnhancedTextElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();

	const [CreateEnhancedTextElement, isCreatingMarkMistakeElement] =
		useMutation<CreateEnhancedTextElementButton_CreateEnhancedTextElementMutation>(
			CREATE_ENHANCED_TEXT_ELEMENT_MUTATION,
		);
	return (
		<Button
			disabled={isCreatingMarkMistakeElement}
			tooltip={t("educationalOffer.createAdvancedTextTooltip")}
			icon={EpicIcons.LANGUAGE}
			onClick={() => {
				CreateEnhancedTextElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							text: "",
							eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
